/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { parseDependencies } from './dependenciesParse.generated.js';
import { createHelpClass } from '../../factoriesAny.js';
export var HelpDependencies = {
  parseDependencies,
  createHelpClass
};